import e from "react";
import E from "classnames";
import { useTranslation as d } from "react-i18next";
import { CheerfyFont as _ } from "../CheerfyFont/CheerfyFont.js";
import { TicketStatus as r } from "../../../api/models/ticket/ticket.types.js";
import { getTicketStatusKey as p } from "../../../api/models/ticket/utils.js";
import a from "./orderRecord.module.scss.js";
function C({
  accentTextColor: o,
  accentColor: n,
  record: t
}) {
  var c, m;
  const {
    t: l
  } = d(), s = t.status !== r.CANCELLED && t.status !== r.COMPLETED, i = (c = t.ticketService) == null ? void 0 : c.getServiceKey(), u = p(t.status);
  return /* @__PURE__ */ e.createElement("div", { "data-testid": "order-record", className: a.record }, /* @__PURE__ */ e.createElement("div", { className: a.record__title }, /* @__PURE__ */ e.createElement("div", null, "#", t.ticketNumber, " ", t.scope.location.name), i && /* @__PURE__ */ e.createElement(_, { icon: i })), /* @__PURE__ */ e.createElement("div", { className: a.record__content }, t.ticketSummary.getFormattedTotal()), /* @__PURE__ */ e.createElement("div", { className: a.record__status }, /* @__PURE__ */ e.createElement(
    "span",
    {
      className: E({
        [a.record__status__chip]: s
      }),
      style: {
        backgroundColor: s ? n : "initial",
        color: s ? o : "inherit"
      }
    },
    l(`${u}`)
  ), t.status === r.COMPLETED && /* @__PURE__ */ e.createElement(e.Fragment, null, "  ", (m = t.ticketService) == null ? void 0 : m.getReadyAtTime())));
}
export {
  C as OrderRecord
};
//# sourceMappingURL=OrderRecord.js.map
